import _HslLib from '../_HslLib'
import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import { JSONToCSVConvertor, createReportLabel } from '../utils'
import { CUSTOMER_LABEL } from '../constants/customerEvents/customerEventLabels'
export default {

  data: function () {
    return {
      deviceList: [],
      applyBtnDisabled: false,
      startOffset: 0,
      currentPage: 1,
      hasNextPage: false,
      requestData: null,
      perPage: 20,
      pageNumber: 1,
      searchString: '',
      numdaysActive: '',
      searchDeviceID: '',
      dateFrom: '',
      dateTo: '',
      typeSelection: null,
      tenantSelection: null,
      statusSelection: null,
      LbDeviceID: '',
      errorMessage: '',
      fields: {
        leakbotId: {
          label: 'LeakBot ID',
          sortable: false
        },
        eventId: {
          label: 'Event ID',
          sortable: false
        },
        tenant: {
          label: 'Tenant',
          sortable: false
        },
        postCode: {
          label: 'Postcode',
          sortable: false,
          formatter: this.translate
        },
        installTimestamp: {
          label: 'Install timestamp',
          sortable: false
        },
        created: {
          label: 'Leak active date',
          sortable: false
        },
        closedDisplayed: {
          label: 'Leak closed',
          sortable: false
        },
        numdaysActive: {
          label: 'Number of days active',
          sortable: false
        },
        diagnosisGroup: {
          label: 'Diagnostic group',
          sortable: false,
          formatter: this.translate
        },
        needHelp: {
          label: 'Need Help',
          sortable: false,
          formatter: this.translate
        },
        repairComplete: {
          label: 'Repair Complete',
          sortable: false,
          formatter: this.translate
        },
        crmBusinessCode: {
          label: 'CRM Action',
          sortable: false,
          formatter: this.actionTranslation
        },
        crmBusinessTimestamp: {
          label: 'CRM Action Date',
          sortable: false,
          formatter: this.nullFormatter
        }
      }
    }
  },
  computed: {
    tenants () {
      return this.$store.state.tenantsList
    }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchLeakListData()
    }
  },
  methods: {
    fetchLeakListData (offset, data) {
      data = data || {}
      data.start_record = typeof offset === 'undefined' ? '0' : offset.toString()
      data.fetch_size = this.perPage
      this.requestData = data
      this.$store.dispatch(APIEvent.FETCH_LEAK_LIST, data)
        .then(this.fetchLeakListResponseHandler)
        .catch(this.handleError)
    },
    fetchLeakListResponseHandler (res) {
      var records = res.data.list.records
      this.applyBtnDisabled = false
      if (!records) return
      for (var i = 0; i < records.length; i++) {
        var record = records[i]
        if (record.closed === 'null' && record.orig_id === '0') {
          record.numdaysActive = Math.round(Math.abs((new Date() - new Date(record.created.replace(' ', 'T') + 'Z')) / (24 * 60 * 60 * 1000)))
        } else if (record.closed === 'null') {
          record.closed = 'N/A'
          record.closedDisplayed = 'N/A'
          record.numdaysActive = 'N/A'
        } else {
          record.closedDisplayed = record.closed
          record.numdaysActive = Math.round(Math.abs((new Date(record.closed.replace(' ', 'T') + 'Z') - new Date(record.created.replace(' ', 'T') + 'Z')) / (24 * 60 * 60 * 1000)))
        }
        if (record.orig_id === '0') {
          record.eventId = record.id
        } else {
          record.eventId = record.orig_id
        }
        if (record.isVIP === '1') {
          record._rowVariant = 'danger'
        }
      }
      if (this.download) {
        this.downloadHandler(records)
        // should we continue to display the data here?
        // return
      }
      this.pageNumber = (this.startOffset / this.perPage) + 1
      this.deviceList = records
      this.$store.commit('SET_LEAKLIST', records)
      this.hasNextPage = res.data.LastPage === '0'
    },
    handleError (error) {
      console.log(error)
      let message = error.message
      this.applyBtnDisabled = false
      switch (error.error) {
        case 209:
          message = 'Device ID is not in the expected format'
          break
        case 305:
          message = 'No matches found'
          break
        case 507:
          message = 'You are not permitted to view the customer profile'
          break
        case 511:
          message = 'Device ID has not been paired with a registered customer account'
          break
      }
      error.message = message
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    },
    isValidDate (date) {
      if (date === '') {
        return false
      }
      return (_HslLib.isValidDate(date))
    },
    search () {
      if (!this.download) {
        this.resetTable()
      }
      let startOffset = this.startOffset
      let searchString = this.searchDeviceID
      let status = this.statusSelection === null ? '' : this.statusSelection
      let tenant = this.tenantSelection === null ? '' : this.tenantSelection.id
      let helpFilter = this.typeSelection === null ? '' : this.typeSelection
      var id = ''
      var dateFrom = this.dateFrom !== '' ? this.dateFrom + ' 00:00:00' : ''
      var dateTo = this.dateTo !== '' ? this.dateTo + ' 23:59:59' : ''

      if (dateFrom <= dateTo) {
        if (searchString !== '') {
          this.$store.dispatch(APIEvent.SEARCH, {searchType: 'LeakBotId', searchString})
            .then((results) => {
              id = results[0].lb_id
              this.sanitiseSearchData({startOffset, id, status, tenant, dateFrom, dateTo, helpFilter})
            })
            .catch(this.handleError)
        } else {
          this.sanitiseSearchData({startOffset, id, status, tenant, dateFrom, dateTo, helpFilter})
        }
      }
      if (dateFrom > dateTo) {
        let message = 'Please enter a valid date before clicking on Apply.'
        EventBus.$emit(StatusBarEvent.ERROR, message)
        this.applyBtnDisabled = false
      }
    },
    getSearchProp (propName) {
      let props = {
        tenant: 'XaTenant_ID',
        id: 'LbDevice_ID',
        status: 'status_id',
        startOffset: 'start_record',
        dateFrom: 'date_from',
        dateTo: 'date_to',
        helpFilter: 'app_flow_selection'
      }
      let retValue = props[propName]
      return retValue || propName
    },
    sanitiseSearchData (options) {
      options.id = (typeof options.id !== 'undefined') ? options.id : ''
      let data = {'type_id': '1'}
      for (var prop in options) {
        if (typeof options[prop] !== 'undefined' && options[prop] !== '') {
          data[this.getSearchProp(prop)] = options[prop].toString()
        }
      }

      data.fetch_size = this.perPage.toString()
      switch (options.status) {
        case 'open':
          data.status_id = '1'
          break
        case 'closed':
          data.status_id = '6'
          break
        default:
          break
      }

      this.deviceList = []
      this.fetchLeakListData(this.startOffset, data)
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
      } else {
        this.startOffset -= this.perPage
      }
      this.fetchLeakListData(this.startOffset, this.requestData)
    },
    translate (value) {
      let translations = {
        'null': '',
        'LeakingToilet': 'Leaking toilet',
        'DrippingTap': 'Dripping tap',
        'Noneofthese': 'None of these',
        'GetHelp': 'Get help',
        'FixMyself': 'Fix myself',
        'AllFixed': 'All fixed',
        'CustomerRepaired': 'Customer repaired'
      }
      return typeof translations[value] === 'undefined'
        ? value
        : translations[value]
    },
    actionTranslation: function (value) {
      return CUSTOMER_LABEL[value]
    },
    nullFormatter: function (value) {
      return value === 'NA' ? '-' : value
    },
    resetTable () {
      this.applyBtnDisabled = true
      this.download = false
      this.perPage = 20
      this.startOffset = 0
      this.hasNextPage = false
      this.pageNumber = 1
      this.errorMessage = ''
    },
    downloadReport () {
      // This will get the first 200 from the leak list
      this.download = true
      this.perPage = 200
      // pass the current start offset so entire records
      // can be manually downloaded
      this.search()
      // This just exports current data in view
      // this.downloadHandler(this.deviceList)
    },
    downloadHandler (records) {
      var headings = {
        leakbotId: 'DeviceID',
        eventId: 'EventID',
        tenant: 'tenantHeading',
        postCode: 'postCodeHeading',
        installTimestamp: 'installTimestampHeading',
        created: 'leakActiveDate',
        closed: 'leakClosedDate',
        numdaysActive: 'daysActive',
        diagnosisGroup: 'diagnosisGroupHeading',
        needHelp: 'needHelpHeading',
        repairComplete: 'repairCompleteHeading',
        crmBusinessCode: 'crmBusinessCodeHeading',
        crmBusinessTimestamp: 'crmBusinessTimestampHeading'
      }
      this.perPage = 20
      this.download = false
      var JsonData = JSON.stringify(records)
      if (JsonData !== '') {
        var title = createReportLabel('Leak List')
        JSONToCSVConvertor(JsonData, title, true, headings)
      }
    }
  }
}
